import { IconButton, Tooltip } from '@mui/joy'
import LogoutIcon from '@mui/icons-material/Logout';
import { logout } from '../../controllers/auth';
import { useDispatchContext } from '../../Store/Context';
const TopBand = () => {

	const dispatch: Function = useDispatchContext();

	async function handleLogout() {
		await logout(dispatch);
	}

	return (
		<div className='flex flex-row justify-between'>
			<div>
				<img src='/webmark.png' alt='webmark-logo' style={{width: "40px"}} />
			</div>
			<div>
				<Tooltip variant='outlined' arrow color='primary' title="Logout">
					<IconButton onClick={handleLogout} variant='plain' color='neutral'>
						<LogoutIcon/>
					</IconButton>
				</Tooltip>
			</div>
		</div>
	)
}

export default TopBand;